import { render, staticRenderFns } from "./ChallengeForumTopic.vue?vue&type=template&id=0313bbcb&scoped=true"
import script from "./ChallengeForumTopic.vue?vue&type=script&lang=ts"
export * from "./ChallengeForumTopic.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeForumTopic.vue?vue&type=style&index=0&id=0313bbcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0313bbcb",
  null
  
)

export default component.exports